import gql from "graphql-tag";

/** Put a listing back on the market and clear sold state. */
export default gql`
  mutation relistListing($id: Int!) {
    updateCarsForSaleById(
      input: {
        id: $id
        carsForSalePatch: {
          active: true
          sold: false
        }
      }
    ) {
      clientMutationId
      carsForSale {
        id
        active
        sold
        soldAt
        soldToUserId
      }
    }
  }
`;
